module.exports = __webpack_public_path__ + "static/media/ios-light-theme.266bfe6f.png";